import React from 'react';
import { Box } from '@mui/material';
import { spacing } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { generateTestId } from 'app/functions';

export const OrderHistorySection = ({ testID }) => (
  <Box
    testId={testID}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: `${spacing.xxxl}px`,
    }}
  >
    <TextHot testID={generateTestId(testID, 'title')} size="xl" bold="bold" color="primary">
      היסטורית הזמנות
    </TextHot>
    <TextHot testID={generateTestId(testID, 'subtitle')} size="m" color="subtle">
      תוכן זה יתווסף בקרוב
    </TextHot>
  </Box>
);

export default OrderHistorySection;

